export default {
  title: 'หนังสือรับรองออนไลน์',
  home: 'หน้าหลัก',
  'table-title': 'รายการหนังสือรับรอง',
  'table-count': '{{count}} รายการในหน้านี้',
  'selected-count': 'เลือก {{count}} รายการ',
  'filter-form': {
    'certificate-label': 'ชื่อหนังสือรับรอง',
    'status-label': 'สถานะ',
    'certificate-placeholder': 'ค้นหาด้วยชื่อหนังสือรับรอง',
    'status-placeholder': 'กรุณาเลือก'
  },
  table: {
    sort: 'ID',
    id: '',
    'certificate-en': 'รายละเอียดเพิ่มเติม (ภาษาอังกฤษ)',
    'certificate-th': 'รายละเอียดเพิ่มเติม (ภาษาไทย)',
    status: 'สถานะ'
  },
  button: {
    action: 'ดำเนินการ',
    delete: 'ลบรายการ'
  },
  form: {
    guided: {
      general: 'ข้อมูลและแม่แบบไทย/อังกฤษ',
      utility: 'ฟิลด์เพิ่มเติม',
      main: 'การส่งเอกสารทั่วไป',
      group: 'การส่งเฉพาะกลุ่ม',
      running: 'เลขที่เอกสาร',
      'template-th': 'แม่แบบภาษาไทย (.docx)',
      'template-en': 'แม่แบบภาษาอังกฤษ (.docx)'
    },
    'title-edit': 'แก้ไขหนังสือรับรองออนไลน์',
    'title-add': 'เพิ่มหนังสือรับรองออนไลน์',
    breadcrumb: {
      home: 'หน้าหลัก',
      previous: 'หนังสือรับรองออนไลน์'
    },
    group: 'กลุ่ม',
    company: 'บริษัท',
    'general-field': {
      status: {
        label: 'สถานะ'
      },
      'name-th': {
        label: 'ชื่อหนังสือรับรอง (ภาษาไทย)',
        placeholder: 'ชื่อหนังสือรับรอง (ภาษาไทย)'
      },
      'name-en': {
        label: 'ชื่อหนังสือรับรอง (ภาษาอังกฤษ)',
        placeholder: 'ชื่อหนังสือรับรอง (ภาษาอังกฤษ)'
      },
      'start-date': {
        label: 'วันที่มีผลตั้งแต่',
        placeholder: 'วันที่มีผลตั้งแต่'
      },
      'end-date': {
        label: 'วันที่มีผลถึง',
        placeholder: 'วันที่มีผลถึง'
      }
    },
    'ufield-title': 'ตั้งค่าฟิลด์เพิ่มเติม',
    'pdf-password-unsupported':
      'ไฟล์ PDF ยังไม่รองรับรหัสผ่าน กรุณาปิดการใส่รหัสหรือเลือกไฟล์ Word',
    ufield: {
      'source-label': 'แหล่งข้อมูล',
      'source-manual': 'ให้ผู้ขอกรอก',
      'source-manual-dropdown': 'ให้ผู้ขอเลือกจากรายการ',
      'dropdown-auth-unsupported':
        'Drop down ไม่รองรับข้อมูลจาก Auth กรุณาเปลี่ยนแหล่งข้อมูล หรือเปลี่ยนชนิดเป็น Text Box',
      'source-auth': 'ดึงข้อมูลจาก Auth',
      'auth-key-label': 'ข้อมูลจาก Auth',
      'auth-key-placeholder': 'เลือกข้อมูล',
      'auth-catalog-failed':
        'โหลดรายการข้อมูลจาก Auth ไม่สำเร็จ กรุณาลองอีกครั้ง',
      'auth-catalog-retry': 'ลองอีกครั้ง',
      'auth-key-unavailable':
        'ข้อมูลที่บันทึกไว้ไม่อยู่ในรายการ กรุณาเลือกใหม่',
      'textbox-name-th': {
        label: 'ชื่อกล่องข้อความ (ภาษาไทย)',
        placeholder: 'ชื่อกล่องข้อความ (ภาษาไทย)'
      },
      'textbox-name-en': {
        label: 'ชื่อกล่องข้อความ (ภาษาอังกฤษ)',
        placeholder: 'ชื่อกล่องข้อความ (ภาษาอังกฤษ)'
      },
      'dropdown-name-th': {
        label: 'ชื่อเมนูตัวเลือก (ภาษาไทย)',
        placeholder: 'ชื่อเมนูตัวเลือก'
      },
      'dropdown-name-en': {
        label: 'ชื่อเมนูตัวเลือก (ภาษาอังกฤษ)',
        placeholder: 'ชื่อเมนูตัวเลือก'
      },
      'dropdown-value-th': {
        label: '',
        placeholder: 'ตัวเลือกในเมนูตัวเลือก'
      },
      'dropdown-value-en': {
        label: '',
        placeholder: 'ตัวเลือกในเมนูตัวเลือก'
      },
      'country-name-th': {
        label: 'ชื่อประเทศ (ภาษาไทย)',
        placeholder: 'ชื่อประเทศ (ภาษาไทย)'
      },
      'country-name-en': {
        label: 'ชื่อประเทศ (ภาษาอังกฤษ)',
        placeholder: 'ชื่อประเทศ (ภาษาอังกฤษ)'
      },
      'date-name-th': {
        label: 'ฟิลด์วันที่ (ภาษาไทย)',
        placeholder: 'ฟิลด์วันที่'
      },
      'date-name-en': {
        label: 'ฟิลด์วันที่ (ภาษาอังกฤษ)',
        placeholder: 'ฟิลด์วันที่'
      },
      button: {
        'add-u-field': 'เพิ่มฟิลด์เพิ่มเติม',
        'add-country-field': 'เพิ่มฟิลด์ประเทศ',
        'add-date-field': 'เพิ่มฟิลด์วันที่'
      }
    },
    'main-title': 'การตั้งค่า',
    'main-setup': {
      'send-doctype': {
        label: 'การออกเอกสาร'
      },
      email1: {
        label: 'Email 1',
        placeholder: 'กรุณาระบุ'
      },
      email2: {
        label: 'Email 2',
        placeholder: 'กรุณาระบุ'
      },
      email3: {
        label: 'Email 3',
        placeholder: 'กรุณาระบุ'
      },
      'is-enable-password': {
        label: 'การใส่รหัส'
      },
      password: {
        label: '',
        placeholder: 'ตั้งรหัสผ่าน'
      },
      doctype: {
        label: 'ประเภทไฟล์'
      }
    },
    'group-title': 'การตั้งค่าเฉพาะกลุ่ม',
    'group-setup': {
      petitioner: {
        label: 'เฉพาะกลุ่ม',
        placeholder: 'เฉพาะกลุ่ม'
      },
      'send-doctype': {
        label: 'การออกเอกสารเฉพาะกลุ่ม'
      },
      email1: {
        label: 'Email 1',
        placeholder: 'กรุณาระบุ'
      },
      email2: {
        label: 'Email 2',
        placeholder: 'กรุณาระบุ'
      },
      email3: {
        label: 'Email 3',
        placeholder: 'กรุณาระบุ'
      },
      'is-enable-password': {
        label: 'การใส่รหัส'
      },
      password: {
        label: '',
        placeholder: 'ตั้งรหัสผ่าน'
      },
      doctype: {
        label: 'ประเภทไฟล์'
      }
    },
    'running-title': 'การตั้งค่าการเรียงลำดับตัวเลข',
    'running-field': {
      'is-enable': {
        label: 'เรียงลำดับตัวเลข'
      },
      'max-digi': {
        label: 'จำนวนหลัก',
        placeholder: 'Please fill'
      },
      'start-digi': {
        label: 'เลขเริ่มต้น',
        placeholder: 'Please fill'
      },
      'text-box': {
        label: '',
        placeholder: 'ชื่อกล่องข้อความ'
      }
    }
  },
  'delete-row-modal': {
    title: 'E-Certificate',
    content: 'คุณต้องการลบรายการที่เลือกหรือไม่',
    button: {
      accept: 'ใช่',
      cancel: 'ไม่ใช่'
    }
  },
  'company-table': require('./CompanyTable.js').default
}
